import http from 'hub-http/clients/apiClient';
import formatCosIndexObject from '../formatters/formatCosIndexObject';
const BASE_URI = 'cosindex/api/v1/connections/parents';

// Should be kept in sync with https://tools.hubteam.com/api-catalog/services/CosIndexService/v1/spec/internal#operations-Connections-get-%2Fcosindex%2Fapi%2Fv1%2Fconnections%2Fparents

export const createGetCosIndexConnectionsParents = (httpClient = http, portalId) => (query = {}) => ids => {
  return httpClient.get(BASE_URI, {
    query: Object.assign({}, query, {
      id: ids
    }, portalId && {
      portalId
    })
  }).then(formatCosIndexObject);
};